<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item>
              <span slot="label">
                项&nbsp;&nbsp;&nbsp;目
              </span>
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="时间">
              <a-range-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="6" :md="6" :sm="24">
            <a-form-item label="供货商">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['supplierId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="supplierList"
                v-model="queryParam.supplierId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="6" :sm="24">
            <a-form-item label="采购人">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['purchaserId', {rules: [{required: true, message: '请选择'}]}]"
                :options="purchaserList"
                v-model="queryParam.purchaserId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="6" :md="6" :sm="24">
            <a-form-item label="名称">
              <a-input
                :disabled="showable"
                placeholder="请输入名称"
                v-model="queryParam.name"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
        </div>
      </a-form>
    </div>
    <s-table
      :isInquire="false"
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropSupplierList } from '@/api/common/SxSupplier'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { dropDownByCode } from '@/api/sys/user'
import { fetchList, download } from '@/api/statement/fixedAssetsCost'

export default {
  name: 'FixedAssetsCost',
  mixins: [TableMixin],
  data () {
    return {
      projectList: [], // 项目
      supplierList: [], // 供货人
      purchaserList: [], // 采购人
      clearDate: undefined,
      showable: false,
      queryParam: {
        projectId: undefined,
        supplierId: undefined,
        startTime: undefined,
        endTime: undefined,
        purchaserId: undefined,
        name: undefined
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '规格',
          dataIndex: 'format'
        },
        {
          title: '数量',
          dataIndex: 'number'
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
        {
          title: '供应商',
          dataIndex: 'supplier'
        },
        {
          title: '采购人',
          dataIndex: 'purchaser'
        },
        {
          title: '预付款',
          dataIndex: 'advancePay',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '总金额',
          dataIndex: 'totalPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH-mm-ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH-mm-ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropSupplierList().then(res => {
        this.supplierList = res.data
      })
      dropDownByCode(this.purchaserQuery).then(res => {
        this.purchaserList = res.data
      })
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '固定资产成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
